import React, { FC, useEffect } from 'react';
import { LandscapeAboutLandscapeTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchLandscapeById } from '../../../store/landscapeAPI/landscape/reducers/landscape.slice';
import cn from 'classnames';
import styles from './LandscapeAboutLandscapePage.module.css';
import Spinner from '../../atoms/Spinner/Spinner';
import { deleteEntityGalleryTile } from '../../../store/landscapeAPI/galleryTile/reducers/entity-gallery-tile.slice';
import { LocalesLanguagesConstants } from '../../../locales/locales';

interface LandscapeAboutLandscapePageProps {}

const LandscapeAboutLandscapePage: FC<
  LandscapeAboutLandscapePageProps
> = () => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { landscape, status } = useSelector(
    (state: RootState) => state.landscapeSlice
  );

  useEffect(() => {
    if (id) {
      dispatch(
        fetchLandscapeById({ id: id, language: LocalesLanguagesConstants.en })
      );
    }
  }, [dispatch, id]);

  const handleEdit = (galleryTileId: string) => {
    navigate(`/landscapes/edit/${id}/about/landscape/edit/${galleryTileId}`);
  };

  const handleDelete = async (galleryTileId: string) => {
    if (id) {
      await dispatch(
        deleteEntityGalleryTile({ existingId: galleryTileId, compactId: id })
      );
      dispatch(
        fetchLandscapeById({ id: id, language: LocalesLanguagesConstants.en })
      );
    }
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.lanscapeAboutLandscapeWrapper)}>
      <LandscapeAboutLandscapeTemplate
        galleryTiles={landscape?.galleryTiles ?? []}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default LandscapeAboutLandscapePage;
